import { render, staticRenderFns } from "./ConfigSelect.vue?vue&type=template&id=449423d2&"
import script from "./ConfigSelect.vue?vue&type=script&lang=ts&"
export * from "./ConfigSelect.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports